export default __webpack_public_path__ + "static/media/sample1.68c04bf7.jpeg";